var fillInPage = (function () {
  var updateCityText = function (geoipResponse) {
    var cityName = geoipResponse.country.iso_code || "your country";
    document.querySelectorAll("p[data-geo]").forEach((item) => {
      item.setAttribute("data-geo", cityName);
    });
  };

  var onSuccess = function (geoipResponse) {
    updateCityText(geoipResponse);
  };

  // If we get an error, we will display an error message
  var onError = function (error) {
    console.error("GeoIP2 log: an error!  Please try again..");
  };

  return function () {
    if (typeof geoip2 !== "undefined") {
      geoip2.city(onSuccess, onError);
    } else {
      console.error("GeoIP2 log: a browser that blocks GeoIP2 requests");
    }
  };
})();

fillInPage();
